import { useState, useEffect } from 'react'
import {
  EuiBasicTable,
  EuiText,
  EuiSpacer,
  EuiHorizontalRule,
  Comparators,
  EuiButton,
  EuiFlexItem,
  EuiFlexGroup,
} from '@elastic/eui'

import AdminKpisModal from './AdminKpisModal'
import kpiService from '../services/kpi.service'

export default function AdminKpisList() {
  const [spinnerGenerateShown, setGenerateSpinnerShown] = useState(false)
  const [spinnerComputeShown, setComputeSpinnerShown] = useState(false)
  const [reports, setReports] = useState([])
  const [isLoading, setIsLoading] = useState(true)

  const [pageIndex, setPageIndex] = useState(0)
  const [pageSize, setPageSize] = useState(100)

  const [sortField, setSortField] = useState('document.id')
  const [sortDirection, setSortDirection] = useState('desc')

  const [pageOfItems, setPageOfItems] = useState([])
  const [totalItemCount, setTotalItemCount] = useState(0)

  const [kpiDocument, setKpiDocument] = useState({})
  const [kpiCode, setKpiCode] = useState('')

  const onTableChange = ({ page = {}, sort = {} }) => {
    const { index: pageIndex, size: pageSize } = page

    const { field: sortField, direction: sortDirection } = sort

    setPageIndex(pageIndex)
    setPageSize(pageSize)
    setSortField(sortField)
    setSortDirection(sortDirection)
  }

  useEffect(() => {
    if (!isLoading) {
      setTotalItemCount(reports.length)
      const startIndex = pageIndex * pageSize
      setPageOfItems(
        reports
          .slice()
          .sort(
            Comparators.property(sortField, Comparators.default(sortDirection)),
          )
          .slice(startIndex, Math.min(startIndex + pageSize, reports.length)),
      )
    }
  }, [reports, isLoading, pageIndex, pageSize, sortField, sortDirection])

  useEffect(() => {
    getReports()
  }, [])

  //Modal
  const [isModalVisible, setIsModalVisible] = useState(false)

  const showModal = (item) => {
    console.log(item)
    setIsModalVisible(true)
    setKpiCode(item.code)
    setKpiDocument(item)
  }
  const closeModal = () => {
    setIsModalVisible(false)
  }

  const getReports = () => {
    kpiService
      .getKpis()
      .then(async (response) => {
        console.log('Axios response => ', response)
        const rows = response.data
        if (!rows || !rows[0]) {
          setReports([])
          setIsLoading(false)
        } else {
          for (var r in rows) {
            rows[r].document.code = rows[r].code
          }

          console.log('Reports rows', rows)
          setReports(rows)
          setIsLoading(false)
        }
      })
      .catch((error) => {
        console.log('Axios error => ', error)
      })
  }

  const generate = () => {
    setGenerateSpinnerShown(true)
    kpiService
      .setGenerate()
      .then(function () {
        setGenerateSpinnerShown(false)
        getReports()
      })
      .catch(function () {})
  }

  const compute = (code, cb) => {
    console.log('compute')
    setComputeSpinnerShown(true)
    kpiService
      .setCompute(code)
      .then(function () {
        getReports()

        setComputeSpinnerShown(false)
        if (typeof cb == 'function') {
          cb()
        }
      })
      .catch(function (err) {
          console.error(err)
      })
      .finally(() => {
         console.log('finaly')
         setComputeSpinnerShown(false)
       })

  }

  const columns = [
    {
      field: 'code',
      name: 'Code',
      dataType: 'string',
      sortable: true,
    },
    {
      field: 'document',
      name: 'Path',
      dataType: 'string',
      sortable: true,
      render: (document) =>
        typeof document.path_titles !== undefined ? (
          <EuiButton
            style={{ position: 'relative', float: 'right' }}
            id="buttonAdminKPIS"
            onClick={() => showModal(document)}
          >
            {JSON.stringify(document.path_titles)}
          </EuiButton>
        ) : (
          ''
        ),
    },

    {
      field: 'document.perimetre_supervise.report',
      name: 'Perimetre supervise',
      dataType: 'string',
      sortable: true,
    },
    {
      field: 'document.log.report',
      name: 'Log',
      dataType: 'string',
      sortable: true,
    },
  ]

  const sorting = {
    sort: {
      field: sortField,
      direction: sortDirection,
    },
  }

  const pagination = {
    pageIndex: pageIndex,
    pageSize: pageSize,
    totalItemCount: totalItemCount,
    pageSizeOptions: [100, 200, 0],
    showPerPageOptions: true,
  }

  const resultsCount =
    pageSize === 0 ? (
      <strong>All</strong>
    ) : (
      <>
        <strong>
          {pageSize * pageIndex + 1}-{pageSize * pageIndex + pageSize}
        </strong>{' '}
        of {totalItemCount}
      </>
    )

  return (
    <>
      <AdminKpisModal
        isModalVisible={isModalVisible}
        closeModal={closeModal}
        compute={compute}
        kpiCode={kpiCode}
        kpiDocument={kpiDocument}
        setKpiDocument={setKpiDocument}
      />
      <EuiText size="xs">
        Showing {resultsCount} <strong>Kpis</strong>
      </EuiText>
      <EuiSpacer size="s" />
      <EuiHorizontalRule margin="none" style={{ height: 2 }} />
      <EuiBasicTable
        loading={isLoading}
        items={pageOfItems}
        itemId="id"
        isExpandable={true}
        columns={columns}
        pagination={pagination}
        sorting={sorting}
        tableLayout="auto"
        onChange={onTableChange}
      />
      <EuiFlexGroup
        key="reports"
        gutterSize="s"
        alignItems="center"
        responsive={false}
        wrap
      >
        <EuiFlexItem grow={false}>
          <EuiButton
            isLoading={spinnerGenerateShown}
            onClick={() => {
              generate()
            }}
          >
            Regénérer la liste
          </EuiButton>
        </EuiFlexItem>
        <EuiFlexItem grow={false}>
          <EuiButton
            isLoading={spinnerComputeShown}
            onClick={() => {
              compute()
            }}
          >
            Relancer l'agrégation
          </EuiButton>
        </EuiFlexItem>
      </EuiFlexGroup>
    </>
  )
}
